export default {
   /* eslint-disable key-spacing */
   '01': 'PMA',
   '02': 'PMDN',
   /* eslint-enable key-spacing */
}
